const agreements = [
  `**I want to receive Water4All water billing assistance 
    for my primary residence.**`,
  `I understand that my application information will be reviewed and verified by the Mayor’s Office of Children and Family Success AND 
    provided to the Baltimore City Department of Public Works to determine the Water4All water billing assistance for which I may be eligible.`,
  `**I consent for my information to be entered into a secure database for tracking services, statistical information, communications, 
    and program evaluation.**`,
  `I declare under penalty of perjury that all the information I provided to the Department of Public Works,
     Bureau of Water and Wastewater is true, correct, and complete to the best of my ability, belief, and knowledge.`,
  `**I certify that I am the named user and resident 
    for this real property located in Baltimore City.**`,
  `I authorize the Mayor’s Office of Children and Family Success and/or Baltimore City Department of Public Works to investigate and 
    confirm the accuracy and completeness of all household income, bank accounts,
    other benefits and other information provided with this application. 
    Maryland has a fraud law that will be vigorously enforced for intentional misrepresentations of information contained on this application.`,
  `**If a household member intentionally misrepresents information, 
    that member may be disqualified from the program for a period of time.**`,
  `Program eligibility is only good for one year.
     Applicants must re-apply each year for approval.`,
  `**I understand that if approved for the Water4All program, 
    the discount will be counted towards my income and may affect other assistance programs that I am currently receiving and may now not be eligible**`,
];

export default agreements;
